import request from '@/http/request'
import {
  getSelectClass,
  getSelectAuthCodeType,
  queryList,
  exportAuthCode,
  exportSerialNumber,
  serialQueryList,
  serialGetSelectClass,
  getPlanExamConfig,
  saveExamConfigOne,
  copyExamConfig,
  saveExamConfigTwo,
  saveExamConfigThree,
  tryExamQueryList,
  tryExamExport,
  tryExamSelectClass,
  getPlanPlaceExamConfig,
  getPlanPlaceExamConfigById,
  savePlanPlaceExamConfig,
  getPlanClassSignTableList,
  exportClassSignTable,
  uploadClassSignTable,
  getPlanPlaceList,
  queryEnterKeyList,
  exportEnterKeyDetail,
  queryEnterKeyDetailList,
  examStudentQueryList,
  queryDetailList,
  versionQueryList,
  queryExamList,
  uploadExamPackageByBatch,
  exportPlaceToPdf,
  queryExamSubmitNum,
  submitByForce,
  uploadExamDataBakByBatch,
  queryExamSubmitList,
  exprotExamSubmitList,
  exprotExamSubmitNum,
  getComputerExamPhotoList,
  uploadComputerExamSinglePhoto,
  checkAllSessionIsEnd,
  uploadComputerExamBatchPhoto,
  getComputerExamClassList,
  getPlanAllSession
} from '@/http/api'




export const getPlanAllSessionAPI = (data) => {
  return request({
    url: getPlanAllSession,
    data,
  })
}

export const getComputerExamClassListAPI = (data) => {
  return request({
    url: getComputerExamClassList,
    data,
  })
}

export const uploadComputerExamBatchPhotoAPI = (data) => {
  return request({
    url: uploadComputerExamBatchPhoto,
    data,
    isUpload: true,
  })
}

export const checkAllSessionIsEndAPI = (data) => {
  return request({
    url: checkAllSessionIsEnd,
    data,
  })
}

export const uploadComputerExamSinglePhotoAPI = (data) => {
  return request({
    url: uploadComputerExamSinglePhoto,
    data,
  })
}

export const getComputerExamPhotoListAPI = (data) => {
  return request({
    url: getComputerExamPhotoList,
    data,
  })
}

export const exprotExamSubmitNumAPI = (data) => {
  return request({
    url: exprotExamSubmitNum,
    data,
  })
}

export const exprotExamSubmitListAPI = (data) => {
  return request({
    url: exprotExamSubmitList,
    data,
  })
}

export const queryExamSubmitListAPI = (data) => {
  return request({
    url: queryExamSubmitList,
    data,
  })
}

export const submitByForceAPI = (data) => {
  return request({
    url: submitByForce,
    data,
  })
}

export const queryExamSubmitNumAPI = (data) => {
  return request({
    url: queryExamSubmitNum,
    data,
  })
}

export const exportPlaceToPdfAPI = (data) => {
  return request({
    url: exportPlaceToPdf,
    data,
  })
}

export const uploadExamDataBakByBatchAPI = (data) => {
  return request({
    url: uploadExamDataBakByBatch,
    data,
    isUpload: true,
  })
}

export const uploadExamPackageByBatchAPI = (data) => {
  return request({
    url: uploadExamPackageByBatch,
    data,
    isUpload: true,
  })
}

export const queryExamListAPI = (data) => {
  return request({
    url: queryExamList,
    data,
  })
}

export const versionQueryListAPI = (data) => {
  return request({
    url: versionQueryList,
    data,
  })
}

export const queryDetailListAPI = (data) => {
  return request({
    url: queryDetailList,
    data,
  })
}

export const examStudentQueryListAPI = (data) => {
  return request({
    url: examStudentQueryList,
    data,
  })
}

export const queryEnterKeyDetailListAPI = (data) => {
  return request({
    url: queryEnterKeyDetailList,
    data,
  })
}

export const exportEnterKeyDetailAPI = (data) => {
  return request({
    url: exportEnterKeyDetail,
    data,
  })
}

export const queryEnterKeyListAPI = (data) => {
  return request({
    url: queryEnterKeyList,
    data,
  })
}

export const getPlanPlaceListAPI = (data) => {
  return request({
    url: getPlanPlaceList,
    data,
  })
}

export const uploadClassSignTableAPI = (data) => {
  return request({
    url: uploadClassSignTable,
    data,
  })
}

export const exportClassSignTableAPI = (data) => {
  return request({
    url: exportClassSignTable,
    data
  })
}

export const getPlanClassSignTableListAPI = (data) => {
  return request({
    url: getPlanClassSignTableList,
    data
  })
}

export const savePlanPlaceExamConfigAPI = (data) => {
  return request({
    url: savePlanPlaceExamConfig,
    data
  })
}

export const getPlanPlaceExamConfigByIdAPI = (data) => {
  return request({
    url: getPlanPlaceExamConfigById,
    data
  })
}

export const getPlanPlaceExamConfigAPI = (data) => {
  return request({
    url: getPlanPlaceExamConfig,
    data
  })
}

export const tryExamSelectClassAPI = (data) => {
  return request({
    url: tryExamSelectClass,
    data
  })
}

export const tryExamExportAPI = (data) => {
  return request({
    url: tryExamExport,
    data
  })
}

export const tryExamQueryListAPI = (data) => {
  return request({
    url: tryExamQueryList,
    data
  })
}

export const saveExamConfigThreeAPI = (data) => {
  return request({
    url: saveExamConfigThree,
    data
  })
}

export const saveExamConfigTwoAPI = (data) => {
  return request({
    url: saveExamConfigTwo,
    data
  })
}

export const getPlanExamConfigAPI = (data) => {
  return request({
    url: getPlanExamConfig,
    data
  })
}

export const saveExamConfigOneAPI = (data) => {
  return request({
    url: saveExamConfigOne,
    data
  })
}

export const copyExamConfigAPI = (data) => {
  return request({
    url: copyExamConfig,
    data
  })
}

export const serialGetSelectClassAPI = (data) => {
  return request({
    url: serialGetSelectClass,
    data
  })
}

export const serialQueryListAPI = (data) => {
  return request({
    url: serialQueryList,
    data
  })
}


export const exportSerialNumberAPI = (data) => {
  return request({
    url: exportSerialNumber,
    data
  })
}

export const exportAuthCodeAPI = (data) => {
  return request({
    url: exportAuthCode,
    data
  })
}

export const queryListAPI = (data) => {
  return request({
    url: queryList,
    data
  })
}

export const getSelectAuthCodeTypeAPI = (data) => {
  return request({
    url: getSelectAuthCodeType,
    data
  })
}

export const getSelectClassAPI = (data) => {
  return request({
    url: getSelectClass,
    data
  })
}